import { createRoot } from 'react-dom/client';
import { AuthProvider, ToastProvider, App } from './gen/_barrel.js';
import './styles.css';

const root = createRoot(document.getElementById('root'));
        root.render(
            <AuthProvider>
                <ToastProvider>
                    <App />
                </ToastProvider>
            </AuthProvider>
        );
